
export enum E_CURRENCY_TYPE {
    STANDARD        = 0,
    GENERIC         = 1,
    CHARACTERISTICS = 2,
    DESK            = 4,
    CHIPS           = 5,
}

export default class Currency {
    id: number
    entity: string
    name: string
    code_name: string
    minor_unit: number
    separator: string
    type_id: E_CURRENCY_TYPE   
    visible: boolean

    constructor(data:any) {
        Object.assign(this, data);
    }

}

